import React, { useContext, useEffect, lazy, Suspense, useGlobal } from "reactn";

// components
import { Header } from "../../../_common/mapHeader/Header";
import { AppWrapper } from "./MainPage.styled";
import Loader from "../../../../components/_common/loader/Loader";

// context
import { StoreLocatorContext } from "../../../../context/Context";

import SidePanel from "../../../_common/sidePanel/sidePanel";
import { virtualPageView } from "../../../../helpers/Helpers";

const List = lazy(() => import("../../../_core/list/List"));
const DetailsPage = lazy(() => import("../details/DetailsPage"));
const MapWrapper = lazy(() => import("../../../_core/map/MapWrapper"));


const MainPage = () => {
	// context
	const { view, setType, setDetails, details, loading, } =
		useContext(StoreLocatorContext);
	const [successfullApiCall, setSuccessfullApiCall] = useGlobal("successfullApiCall");
	const [isCollectionPointFinderActive, setIsCollectionPointFinderActive] = useGlobal("isCollectionPointFinderActive");
	const [isParcelLockerFinderActive, setIsParcelLockerFinderActive] = useGlobal("isParcelLockerFinderActive");

	useEffect(() => {
		isParcelLockerFinderActive && setType("Parcel Locker");

		return () => {
			{ setType("") };
			setIsCollectionPointFinderActive(false);
		}
	}, [isCollectionPointFinderActive, isParcelLockerFinderActive]);


	useEffect(() => {
		const tabTitle = document.title;
		if (isCollectionPointFinderActive && details.Id) {
			virtualPageView(`/myAccount/My-deliveries/delivery-options/collection-point/info`, `${tabTitle} - Delivery options - Collection point- Info`)
			
		} else if (isParcelLockerFinderActive && details.Id) {
			
			virtualPageView(`/myAccount/My-deliveries/delivery-options/parcel-locker/info`, `${tabTitle} - Delivery options - Parcel locker - Info`)
		}
	}, [isCollectionPointFinderActive, isParcelLockerFinderActive, details.Id])


	// check if the app webview useragent "An Post" is loaded
	const anPostAppCheck = () => {
		if (navigator.userAgent.indexOf("An Post") !== -1) {
			const header = document.querySelector(".header");
			if (header) header.style.zIndex = 999999;
			return true;
		} else {
			return false;
		}
	};

	return (
		<>
			<>
				{loading && <Loader />}
				<SidePanel isOpen={details.Id} onClose={() => {
					setDetails("");
					setSuccessfullApiCall(false);
					setIsParcelLockerFinderActive(false)
					setIsCollectionPointFinderActive(false)
				}
				}>
					<DetailsPage />
				</SidePanel>
				<AppWrapper map={view === "map"} mobileApp={anPostAppCheck()}>
					{!anPostAppCheck() && (
						<Header>
							<h1>{
								isParcelLockerFinderActive && "Find a parcel locker"
							}
								{
									isCollectionPointFinderActive && "Find a collection point"
								}
							</h1>
						</Header>
					)}
					<Suspense fallback={<AppWrapper />}>
						{view === "map" && <MapWrapper />}
						{view === "list" && <List />}
					</Suspense>


				</AppWrapper>
			</>
		</>
	);
};

export default MainPage;